<div class="container" [class.open]="!!isOpen">
  <header (click)="isOpen = !isOpen">
    <div class="label">{{ label }}</div>
    <div class="button">{{ isOpen ? "Close" : "Edit" }}</div>
  </header>
  <div class="content">
    <ng-content *ngIf="isOpen"></ng-content>
  </div>
</div>
